import { render, staticRenderFns } from "./com-menu-item.vue?vue&type=template&id=2ee79af1&scoped=true&"
import script from "./com-menu-item.vue?vue&type=script&lang=js&"
export * from "./com-menu-item.vue?vue&type=script&lang=js&"
import style0 from "./com-menu-item.vue?vue&type=style&index=0&id=2ee79af1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee79af1",
  null
  
)

export default component.exports